document.addEventListener('DOMContentLoaded', function () {
  const productMenuSelector = '.product-menu a';
  const toggleClassName = 'active';

  function removeLinkIfSectionExtinct(link) {
    const targetElement = document.querySelector(link.getAttribute('href'));
    if (!targetElement && link.getAttribute('href').startsWith('#')) {
      link.parentElement.remove();
    }
  }

  function isInViewport(elm) {
    const rect = elm.getBoundingClientRect();
    const vpH = window.innerHeight;

    // Buffer to ensure the element is at least 20% visible
    const buffer = vpH * 0.2;

    // Check if the element is at least 20% visible from either the top or bottom
    return (rect.top < vpH - buffer && rect.bottom > buffer) || (rect.top > buffer && rect.bottom < vpH - buffer);
  }

  function handleProductMenuScroll() {
    document.querySelectorAll(productMenuSelector).forEach(function (menuItem) {
      const targetElement = document.querySelector(menuItem.getAttribute('href'));
      if (targetElement) {
        if (isInViewport(targetElement)) {
          document.querySelectorAll(productMenuSelector).forEach(function (item) {
            item.classList.remove(toggleClassName);
          });
          menuItem.classList.add(toggleClassName);
          return false; // Exit the loop
        } else {
          menuItem.classList.remove(toggleClassName);
        }
      }
    });
  }
  
  document.querySelectorAll(productMenuSelector).forEach(function (menuItem) {
    removeLinkIfSectionExtinct(menuItem);
  });

  handleProductMenuScroll();
  document.addEventListener('scroll', handleProductMenuScroll);
});


document.addEventListener('DOMContentLoaded', function () { 
  const productMenuSection = document.querySelector('.shopify-section--product-menu'); 
  if (!productMenuSection) return; /* Update the sticky class based on the header's sticky attribute and the scroll position */ 
  
  function updateStickyClass() { 
    const header = document.querySelector('.header'); 
    const headerIsSticky = header && header.hasAttribute('sticky');
    const shouldStick = headerIsSticky && window.scrollY >= 500; 
    productMenuSection.classList.toggle('is-stuck', shouldStick); 
  } 
  // Initial check 
  updateStickyClass(); 
  // Scroll listener 
  document.addEventListener('scroll', updateStickyClass, { passive: true });
});